import { StyleStatus, ModelNumber } from './types';
import { STATUS_MAP, MODEL_NUMBER_MAP } from './constants';

/**
 * 获取状态文本和颜色
 */
export const getStatusInfo = (status: StyleStatus) => {
  return STATUS_MAP[status] || { text: '未知', color: 'default' };
};

/**
 * 获取模型编号文本
 */
export const getModelNumberText = (model: ModelNumber): string => {
  return MODEL_NUMBER_MAP[model] || '未知';
};

/**
 * 格式化是否值
 */
export const formatYesNo = (value: number | boolean): string => {
  if (typeof value === 'boolean') {
    return value ? '是' : '否';
  }
  return value === 1 ? '是' : '否';
};

